module.exports = __webpack_public_path__ + "img/10.dirty_shower.ae146e0d.svg";